export const MODAL_MESSAGES = {
  SAVE: 'When you update your screener, you will create a new version. '
  + 'Once you create a new screener version, participants will only be able to take the latest screener version.'
  + ' However, if participants have qualified for a previous version, they will still be included in this project.'
  + '\n\nDo you want to save this screener as a new version?',
  CANCEL: 'Do you want to delete your progress? We will not create a new screener version.',
};

export const TOAST_TIME = {
  DEFAULT: 2000,
};
